import axios from "axios";
import { clearLogoutData } from "../logout/action";
import {
  Partner_Service_URL,
  Branch_Gst_Verification_URL,
  Master_Service_TEAMS_URL,
} from "../Url";
import HashMap from "hashmap";

var map = new HashMap();
var err;
function objToStrMap(obj) {
  let strMap = new Map();
  for (let k of Object.keys(obj)) {
    strMap.set(k, obj[k]);
  }
  return strMap;
}

export const getPartnerPanAction = {
  GET_PARTNER_PAN_SUCCESS: "GET_PARTNER_PAN_SUCCESS",
  GET_PARTNER_PAN_ERROR: "GET_PARTNER_PAN_ERROR",
};

export function getPartnerPanDocuments(props) {
  const { accessToken, firmId } = props;
  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + accessToken,
        "Access-Control-Allow-Origin": "*",
      },
      url: `${Partner_Service_URL}/getPanResponseDetailsByPartnerFirmId?partnerFirmId=${firmId}`,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(getPartnerPanSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getPartnerPanError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(getPartnerPanError(err));
          return err.response;
        }
      });
}

export function getPartnerPanError(error) {
  return {
    type: getPartnerPanAction.GET_PARTNER_PAN_ERROR,
    payload: error,
  };
}

export function getPartnerPanSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: getPartnerPanAction.GET_PARTNER_PAN_SUCCESS,
      payload: props,
    });
  };
}

export const getPartnerGstAction = {
  GET_PARTNER_GST_SUCCESS: "GET_PARTNER_GST_SUCCESS",
  GET_PARTNER_GST_ERROR: "GET_PARTNER_GST_ERROR",
};

export function getPartnerGstDocuments(props) {
  const { accessToken, firmId, BranchId } = props;
  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + accessToken,
        "Access-Control-Allow-Origin": "*",
      },
      url: `${Branch_Gst_Verification_URL}/getGSTResponseDetailsByPartnerBranchId?partnerBranchId=${BranchId}&partnerFirmId=${firmId}`,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(getPartnerGstSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getPartnerGstError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(getPartnerPanError(err));
          return err.response;
        }
      });
}

export function getPartnerGstError(error) {
  return {
    type: getPartnerGstAction.GET_PARTNER_GST_ERROR,
    payload: error,
  };
}

export function getPartnerGstSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: getPartnerGstAction.GET_PARTNER_GST_SUCCESS,
      payload: props,
    });
  };
}

export const getTeamPanAction = {
  GET_TEAM_PAN_SUCCESS: "GET_TEAM_PAN_SUCCESS",
  GET_TEAM_PAN_ERROR: "GET_TEAM_PAN_ERROR",
};

export function getTeamPanDocuments(props) {
  const { accessToken, personID } = props;
  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + accessToken,
        "Access-Control-Allow-Origin": "*",
      },
      url: `${Master_Service_TEAMS_URL}/getTeamPanVerificationResponse?partnerPersonId=${personID}`,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(getTeamPanSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getPartnerPanError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(getTeamPanError(err));
          return err.response;
        }
      });
}

export function getTeamPanError(error) {
  return {
    type: getTeamPanAction.GET_TEAM_PAN_ERROR,
    payload: error,
  };
}

export function getTeamPanSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: getTeamPanAction.GET_TEAM_PAN_SUCCESS,
      payload: props,
    });
  };
}

export const getTeamAddharAction = {
  GET_TEAM_ADDHAR_SUCCESS: "GET_TEAM_ADDHAR_SUCCESS",
  GET_TEAM_ADDHAR_ERROR: "GET_TEAM_ADDHAR_ERROR",
};

export function getTeamAddharDocuments(props) {
  const { accessToken, personID } = props;
  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + accessToken,
        "Access-Control-Allow-Origin": "*",
      },
      url: `${Master_Service_TEAMS_URL}/getTeamAadharVerificationResponse?partnerPersonId=${personID}`,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(getTeamAddharSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getTeamAddharError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(getTeamPanError(err));
          return err.response;
        }
      });
}

export function getTeamAddharError(error) {
  return {
    type: getTeamAddharAction.GET_TEAM_ADDHAR_ERROR,
    payload: error,
  };
}

export function getTeamAddharSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: getTeamAddharAction.GET_TEAM_ADDHAR_SUCCESS,
      payload: props,
    });
  };
}

export const getPartnerBankAction = {
  GET_PARTNER_BANK_SUCCESS: "GET_PARTNER_BANK_SUCCESS",
  GET_PARTNER_BANK_ERROR: "GET_PARTNER_BANK_ERROR",
};

export function getPartnerBankDocuments(props) {
  const { accessToken, firmId } = props;
  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + accessToken,
        "Access-Control-Allow-Origin": "*",
      },
      url: `${Partner_Service_URL}/getBankVerificationResponse?partnerFirmId=${firmId}`,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(getPartnerBankSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getPartnerBankError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

          map.forEach((ele) => (err = ele));

          return err;
        }
      });
}

export function getPartnerBankError(error) {
  return {
    type: getPartnerBankAction.GET_PARTNER_BANK_ERROR,
    payload: error,
  };
}

export function getPartnerBankSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: getPartnerBankAction.GET_PARTNER_BANK_SUCCESS,
      payload: props,
    });
  };
}
